// export const environment = {
//   production: false,
//   firebase: {
//     apiKey: "AIzaSyC6AyViu0NWU_EmbDtarKCUz6uPPj6L7eQ",
//     authDomain: "sirical-test.firebaseapp.com",
//     databaseURL: "https://sirical-test.firebaseio.com",
//     projectId: "sirical-test",
//     storageBucket: "sirical-test.appspot.com",
//     messagingSenderId: "932416685572",
//     appId: "1:932416685572:web:983e987184d24e2c5d1751"
//    },
//   googleMaps: {
//     apiKey: "AIzaSyCy68o0Wu2jV0hcge3NrzlVZxL3xHO3JqU"
//   }
// };

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDLE8MfLiFquvS4-7AUYRPzdIaZpvWnp7Q",
    authDomain: "spirical-maps.firebaseapp.com",
    databaseURL: "https://spirical-maps.firebaseio.com",
    projectId: "spirical-maps",
    storageBucket: "spirical-maps-new",
    messagingSenderId: "610183566011"
  },
  firestoreDatabaseId: 'new-tel-aviv',
  storageBucketUrl: 'gs://spirical-maps-new',
  googleMaps: {
    apiKey: "AIzaSyCy68o0Wu2jV0hcge3NrzlVZxL3xHO3JqU"
  }
};
